import NotFoundPageView from './NotFoundPageView';

export default NotFoundPageView;
